/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TestStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}

export enum StorageThumbnailType {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum StorageRecognitionStatus {
  REQUESTED = 'REQUESTED',
  COMPLETED = 'COMPLETED',
}

export enum StorageMenu {
  ALL = 'ALL',
  RECENT = 'RECENT',
  FAVORITE = 'FAVORITE',
}

export enum StorageFileType {
  JPG = 'JPG',
  PNG = 'PNG',
  PDF = 'PDF',
}

export enum StorageFileCategory {
  LABORATORY_REPORT = 'LABORATORY_REPORT',
  MEDICAL_RECORD = 'MEDICAL_RECORD',
  IMAGING_REPORT = 'IMAGING_REPORT',
  MEDICAL_IMAGE = 'MEDICAL_IMAGE',
  PRESCRIPTION = 'PRESCRIPTION',
  MISCELLANEOUS = 'MISCELLANEOUS',
}

/** States of America */
export enum StateType {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AS = 'AS',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DC = 'DC',
  DE = 'DE',
  FL = 'FL',
  FM = 'FM',
  GA = 'GA',
  GU = 'GU',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MH = 'MH',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  PR = 'PR',
  PW = 'PW',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VI = 'VI',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
  ZZ = 'ZZ',
}

export enum SexualOrientationType {
  LESBIAN_GAY_HOMOSEXUAL = 'LESBIAN_GAY_HOMOSEXUAL',
  STRAIGHT_HETEROSEXUAL = 'STRAIGHT_HETEROSEXUAL',
  BISEXUAL = 'BISEXUAL',
  OTH = 'OTH',
  UNK = 'UNK',
  ASKU = 'ASKU',
}

export enum ResultType {
  LABORATORY = 'LABORATORY',
  MANUAL = 'MANUAL',
  IMPORT = 'IMPORT',
}

export enum ResultRequestType {
  LABORATORY = 'LABORATORY',
  MANUAL = 'MANUAL',
  ALL = 'ALL',
}

/** Request relation type */
export enum RequestRelationType {
  CHD = 'CHD',
  DEP = 'DEP',
  FCH = 'FCH',
  FTH = 'FTH',
  GCH = 'GCH',
  GRP = 'GRP',
  MTH = 'MTH',
  SPO = 'SPO',
  HUSB = 'HUSB',
  WIFE = 'WIFE',
}

/** Relation type */
export enum RelationType {
  CHD = 'CHD',
  DEP = 'DEP',
  EMC = 'EMC',
  FCH = 'FCH',
  FTH = 'FTH',
  GCH = 'GCH',
  GRP = 'GRP',
  MTH = 'MTH',
  OTH = 'OTH',
  WRD = 'WRD',
  SPO = 'SPO',
  HUSB = 'HUSB',
  WIFE = 'WIFE',
}

/** Relation Request Send Type */
export enum RelationRequestSendType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  UNSENT = 'UNSENT',
}

/** Relation error type */
export enum RelationErrorType {
  PARENT_AGE_ERROR = 'PARENT_AGE_ERROR',
  LESS_EIGHTEEN_ERROR = 'LESS_EIGHTEEN_ERROR',
  PARENT_GREATER_EIGHTEEN_ERROR = 'PARENT_GREATER_EIGHTEEN_ERROR',
  GREATER_EIGHTEEN_ERROR = 'GREATER_EIGHTEEN_ERROR',
  BIRTH_DATE_ERROR = 'BIRTH_DATE_ERROR',
  BIRTH_SEX_ERROR = 'BIRTH_SEX_ERROR',
  ACCOUNT_STATUS_ERROR = 'ACCOUNT_STATUS_ERROR',
  RELATION_CONTRADICT_ERROR = 'RELATION_CONTRADICT_ERROR',
  RELATION_DUPLICATE_ERROR = 'RELATION_DUPLICATE_ERROR',
  RELATION_REQUEST_DUPLICATE_ERROR = 'RELATION_REQUEST_DUPLICATE_ERROR',
}

export enum RaceType {
  AMERICAN_INDIAN_OR_ALASKA_NATIVE = 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
  ASIAN = 'ASIAN',
  BLACK_OR_AFRICAN_AMERICAN = 'BLACK_OR_AFRICAN_AMERICAN',
  NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER = 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
  WHITE = 'WHITE',
  OTHER = 'OTHER',
  ASKU = 'ASKU',
  UNKNOWN = 'UNKNOWN',
}

/** Phone type */
export enum PhoneType {
  HOME_PHONE = 'HOME_PHONE',
  WORK_PHONE = 'WORK_PHONE',
  MOBILE_PHONE = 'MOBILE_PHONE',
}

export enum PeriodAvailabilityType {
  ONE_WEEK = 'ONE_WEEK',
  TWO_WEEKS = 'TWO_WEEKS',
  THREE_WEEKS = 'THREE_WEEKS',
  ONE_MONTH = 'ONE_MONTH',
  TWO_MONTHS = 'TWO_MONTHS',
  THREE_MONTHS = 'THREE_MONTHS',
  FOUR_MONTHS = 'FOUR_MONTHS',
  FIVE_MONTHS = 'FIVE_MONTHS',
  SIX_MONTHS = 'SIX_MONTHS',
}

export enum NotificationType {
  LABORATORY_RESULT = 'LABORATORY_RESULT',
  SELECTION = 'SELECTION',
}

export enum HealthCaseObjectType {
  RESULT = 'RESULT',
  STORAGE = 'STORAGE',
  APPOINTMENT = 'APPOINTMENT',
}

export enum GenderType {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  FEMALE_TO_MALE = 'FEMALE_TO_MALE',
  MALE_TO_FEMALE = 'MALE_TO_FEMALE',
  GENDERQUEER = 'GENDERQUEER',
  OTH = 'OTH',
  ASKU = 'ASKU',
}

export enum FlagType {
  NORMAL = 'NORMAL',
  ABNORMAL = 'ABNORMAL',
  CRITICAL = 'CRITICAL',
}

export enum EthnicityType {
  HISPANIC_OR_LATINO = 'HISPANIC_OR_LATINO',
  NOT_HISPANIC_OR_LATINO = 'NOT_HISPANIC_OR_LATINO',
  OTH = 'OTH',
  UNK = 'UNK',
  ASKU = 'ASKU',
}

export enum DoubleOptInStatus {
  NOT_SENT = 'NOT_SENT',
  SENT = 'SENT',
  CONFIRMED = 'CONFIRMED',
}

/** Company access type */
export enum CompanyAccessType {
  CREATOR_CONTACT = 'CREATOR_CONTACT',
  DOCUMENT_CREATOR = 'DOCUMENT_CREATOR',
  CONTACT_MEDCARE = 'CONTACT_MEDCARE',
  ACCOUNT_EMPLOYER = 'ACCOUNT_EMPLOYER',
}

export enum BirthSex {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNKNOWN = 'UNKNOWN',
}

export enum AppointmentType {
  IN_PERSON = 'IN_PERSON',
  VIDEO = 'VIDEO',
  HOME_VISIT = 'HOME_VISIT',
}

export enum AppointmentStatus {
  CREATED = 'CREATED',
  WAITINGCONFIRMATION = 'WAITINGCONFIRMATION',
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
}

/** Account status */
export enum AccountStatus {
  NEW = 'NEW',
  ACTIVE = 'ACTIVE',
  INVITE = 'INVITE',
  BLOCKED = 'BLOCKED',
}

/** Account create access type */
export enum AccountCreateAccessType {
  CONTACT_REPRESENT = 'CONTACT_REPRESENT',
  CONTACT_PROXY = 'CONTACT_PROXY',
}

/** Account access type */
export enum AccountAccessType {
  CREATOR_CONTACT = 'CREATOR_CONTACT',
  CREATOR_ACCOUNT = 'CREATOR_ACCOUNT',
  CONTACT_REPRESENT = 'CONTACT_REPRESENT',
  CONTACT_PROXY = 'CONTACT_PROXY',
}

/** Access type */
export enum AccessType {
  ACCOUNT = 'ACCOUNT',
  COMPANY = 'COMPANY',
}

export interface AccessRequest {
  /** Account access type */
  access?: AccountAccessType;
  avatarUrl?: string;
  /** @format date */
  beginDate?: string;
  /** Short contact info for access requests */
  contact?: AccessRequestContact;
  /** @format date-time */
  createdDate?: string;
  emails?: Email[];
  /** @format date */
  endDate?: string;
  /** @format uuid */
  id: string;
  phones?: BasePhone[];
}

/** Short contact info for access requests */
export interface AccessRequestContact {
  firstName?: string;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
}

export interface AccessRequests {
  incoming?: AccessRequest[];
  outgoing?: AccessRequest[];
}

export interface AccessesResponse {
  companyAccesses?: CompanyAccess[];
  incomingAccountAccesses?: AccountAccess[];
  outgoingAccountAccesses?: AccountAccess[];
}

export interface AccountAccess {
  /** Account access type */
  access?: AccountAccessType;
  avatarUrl?: string;
  /** @format date */
  beginDate?: string;
  contact?: Contact;
  /** @format date */
  endDate?: string;
  /** @format uuid */
  id: string;
}

export interface AccountContactEditRequest {
  /** Birth Date */
  birthDate?: NillableLocalDate;
  /** Birth sex */
  birthSex?: NillableBirthSex;
}

export interface AccountCreateAccessRequest {
  /** Account create access type */
  access: AccountCreateAccessType;
  /** @format uuid */
  contactId: string;
  /** @format date */
  endDate?: string;
}

export interface AccountDetails {
  /** @format uuid */
  accountId?: string;
  avatarUrl?: string;
  /** @format date */
  birthDate?: string;
  birthDateS?: string;
  birthSex?: BirthSex;
  email?: string;
  ethnicity?: EthnicityType;
  firstName?: string;
  gender?: GenderType;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
  phone?: string;
  race?: RaceType;
  sexualOrientation?: SexualOrientationType;
  ssnTail?: string;
}

export interface Address {
  /** Additional address */
  additional?: string;
  /** City */
  city?: string;
  /** City replacement */
  cityReplacement?: string;
  /**
   * Contact address id
   * @format uuid
   */
  id: string;
  /** Location */
  location?: AddressLocation;
  /** Main address */
  main?: string;
  /** Postal Code (Zip Code) */
  postalCode?: string;
  /** State */
  state?: StateType;
}

export interface AddressChangeRequest {
  /**
   * @minLength 0
   * @maxLength 55
   */
  address1: string;
  /**
   * @minLength 0
   * @maxLength 55
   */
  address2?: string;
  /**
   * @minLength 0
   * @maxLength 40
   */
  city: string;
  /**
   * City replacement
   * @minLength 0
   * @maxLength 40
   */
  cityReplacement?: string;
  location?: AddressLocation;
  postalCode: string;
  /** States of America */
  state: StateType;
}

export interface AddressLocation {
  googlePlaceId: string;
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
}

export interface AnonymousPatient {
  /** @format date */
  birthDate?: string;
  birthSex?: BirthSex;
  firstName?: string;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
}

export interface AnonymousResultData {
  contentType?: string;
  data?: string;
  lastReportId?: string;
}

export interface Appointment {
  anonymousPatient?: AnonymousPatient;
  /** @format uuid */
  id: string;
  patient?: AccountDetails;
  professional?: ProfessionalShortInfo;
  /** @format date-time */
  startDate?: string;
  status?: AppointmentStatus;
  type?: AppointmentType;
}

export interface AppointmentFile {
  /** @format uuid */
  id: string;
  name?: string;
  /** @format int32 */
  size?: number;
}

export interface AppointmentFileData {
  contentType?: string;
  data?: string;
}

export interface AppointmentFull {
  address?: CompanyAddress;
  anonymousPatient?: AnonymousPatient;
  comment?: string;
  email?: string;
  /** @format date-time */
  endDate?: string;
  files?: AppointmentFile[];
  /** @format double */
  height?: number;
  /** @format uuid */
  id: string;
  insurance?: BaseAppointmentInsuranceRequest;
  patient?: AccountDetails;
  phone?: string;
  professional?: ProfessionalInfo;
  recommendation?: string;
  reviewLeaved?: boolean;
  /** @format date-time */
  startDate?: string;
  status?: AppointmentStatus;
  type?: AppointmentType;
  /** @format double */
  weight?: number;
}

export interface AppointmentReviewRequest {
  /**
   * Explanation rating
   * @format int32
   * @min 1
   * @max 5
   */
  explanationRating: number;
  /**
   * Service rating
   * @format int32
   * @min 1
   * @max 5
   */
  serviceRating: number;
  /**
   * Text
   * @minLength 0
   * @maxLength 500
   */
  text?: string;
}

export interface AttemptsError {
  /** @format int32 */
  attemptsLeft?: number;
}

export interface BMI {
  /** @format date-time */
  createdTime?: string;
  formula?: string;
  /** @format int32 */
  height?: number;
  /** @format uuid */
  id: string;
  value?: number;
  weight?: number;
}

export interface BMICategory {
  maxBmi?: number;
  minBmi?: number;
  name?: string;
}

export interface BMICreateRequest {
  /**
   * @format int32
   * @min 1
   * @max 108
   */
  height: number;
  /**
   * @min 1
   * @max 1323
   */
  weight: number;
}

export interface BMIRecommendation {
  description?: string;
  name?: string;
  recommendation?: string;
}

export type BaseAppointmentInsuranceRequest =
  BaseBaseAppointmentInsuranceRequest &
    (
      | BaseBaseAppointmentInsuranceRequestTypeMapping<
          'CARRIER',
          CarrierAppointmentInsurance
        >
      | BaseBaseAppointmentInsuranceRequestTypeMapping<
          'PLAN',
          PlanAppointmentInsurance
        >
    );

/** Object with error message «Internal Server Error» */
export interface BaseError {
  /** Error message */
  message?: string;
}

/** Base phone */
export type BasePhone = BaseBasePhone & { main?: boolean } & (
    | HomePhone
    | MobilePhone
    | WorkPhone
  );

/** Base create phone request */
export interface BasePhoneCreateRequest {
  /** Phone */
  phone: string;
  /** Phone type */
  type: PhoneType;
}

/** Base relation error */ //@ts-expect-error
export type BaseRelationError = BaseBaseRelationError &
  (
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.ACCOUNT_STATUS_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.BIRTH_DATE_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.BIRTH_SEX_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.GREATER_EIGHTEEN_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.LESS_EIGHTEEN_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.PARENT_AGE_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.PARENT_GREATER_EIGHTEEN_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.RELATION_CONTRADICT_ERROR,
        BaseRelationError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.RELATION_DUPLICATE_ERROR,
        RelationDuplicateError
      >
    | BaseBaseRelationErrorTypeMapping<
        RelationErrorType.RELATION_REQUEST_DUPLICATE_ERROR,
        RelationRequestDuplicateError
      >
  );

/** Base result */
export type BaseResult = BaseBaseResult &
  (
    | BaseBaseResultTypeMapping<ResultType.IMPORT, Result>
    | BaseBaseResultTypeMapping<ResultType.LABORATORY, Result>
    | BaseBaseResultTypeMapping<ResultType.MANUAL, ManualResult>
  );

/** Base result detail */
export type BaseResultDetail = BaseBaseResultDetail &
  (
    | BaseBaseResultDetailTypeMapping<ResultType.IMPORT, ImportResultDetail>
    | BaseBaseResultDetailTypeMapping<
        ResultType.LABORATORY,
        LaboratoryResultDetail
      >
    | BaseBaseResultDetailTypeMapping<ResultType.MANUAL, ManualResultDetail>
  );

/** Base Sent Relation Request Result */
export type BaseSentRelationRequestResult = BaseBaseSentRelationRequestResult &
  (
    | BaseBaseSentRelationRequestResultTypeMapping<
        RelationRequestSendType.EMAIL,
        EmailSentRelationRequestResult
      >
    | BaseBaseSentRelationRequestResultTypeMapping<
        RelationRequestSendType.PHONE,
        PhoneSentRelationRequestResult
      >
    | BaseBaseSentRelationRequestResultTypeMapping<
        RelationRequestSendType.UNSENT,
        UnsentRelationRequestResult
      >
  );

export interface BatchRequestUUID {
  requests: string[];
}

export interface Biomarker {
  /** @format uuid */
  id: string;
  loinc?: string;
  name?: string;
}

export interface BiomarkerUnit {
  /** @format uuid */
  id: string;
  name?: string;
}

export interface BiomarkerUnitSelect {
  /** @format uuid */
  biomarkerId?: string;
  /** @format uuid */
  id: string;
  name?: string;
}

export type CarrierAppointmentInsurance =
  BaseBaseAppointmentInsuranceRequest & {
    /** Insurance carrier */
    carrier?: InsuranceCarrier;
  };

export interface Company {
  description?: string;
  /** @format uuid */
  id: string;
  logoUrl?: string;
  name?: string;
}

export interface CompanyAccess {
  /** Company access type */
  access?: CompanyAccessType;
  /** @format date */
  beginDate?: string;
  company?: Company;
  /** @format date */
  endDate?: string;
  /** @format uuid */
  id: string;
}

export interface CompanyAddress {
  address1?: string;
  address2?: string;
  city?: string;
  cityReplacement?: string;
  /** @format date */
  endDate?: string;
  faxNumber?: string;
  googlePlaceId?: string;
  /** @format uuid */
  id: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  postalCode?: string;
  /** States of America */
  state?: StateType;
  telephoneNumber?: string;
}

export interface Contact {
  /** @format date */
  birthDate?: string;
  birthDateS?: string;
  birthSex?: BirthSex;
  ethnicity?: EthnicityType;
  firstName?: string;
  gender?: GenderType;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
  race?: RaceType;
  sexualOrientation?: SexualOrientationType;
  ssnTail?: string;
}

export interface DatePeriod {
  /** @format date */
  from?: string;
  /** @format date */
  to?: string;
}

export interface DeleteAccessRequest {
  /** Access type */
  type: AccessType;
}

export interface DynamicItem {
  code: string;
  name: string;
  results: DynamicResult[];
  unit: string;
}

export interface DynamicResult {
  comment?: string;
  criticalReference?: Reference;
  /** @format date-time */
  dateTime?: string;
  labTestCode?: string;
  labTestName?: string;
  qualityReference?: QualityReference;
  reference?: Reference;
  type?: ResultType;
  value?: string;
}

export interface DynamicSearchRequest {
  type: ResultRequestType;
}

export interface Email {
  allowResultsDelivery?: boolean;
  doubleOptIn?: DoubleOptInStatus;
  email?: string;
  /** @format uuid */
  id: string;
  main?: boolean;
  ownershipConfirmed?: boolean;
}

export interface EmailCreateRequest {
  email: string;
}

export type EmailSentRelationRequestResult =
  BaseBaseSentRelationRequestResult & {
    email?: string;
  };

export interface EmailUpdateRequest {
  allowResultDelivery?: NillableBoolean;
}

export interface FavoriteProfessional {
  account?: AccountDetails;
  credential?: string;
  specialities?: Speciality[];
  speciality?: Speciality;
  /** @format double */
  totalRating?: number;
  typePrefix?: string;
  typeSuffix?: string;
}

export interface FieldError {
  error?: string;
  field?: string;
}

export interface Guarantor {
  additional?: string;
  /** @format date */
  birthDate?: string;
  birthSex?: BirthSex;
  city?: string;
  firstName?: string;
  lastName?: string;
  main?: string;
  middleName?: string;
  phone?: string;
  postalCode?: string;
  /** Relation type */
  relationType?: RelationType;
  ssnTail?: string;
  /** States of America */
  state?: StateType;
}

export interface GuarantorCreateRequest {
  /**
   * @minLength 0
   * @maxLength 55
   */
  address1: string;
  address2?: NillableString;
  /** @format date */
  birthDate: string;
  birthSex: BirthSex;
  /**
   * @minLength 0
   * @maxLength 40
   */
  city: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  firstName: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  lastName: string;
  middleName?: NillableString;
  phone?: NillablePhoneWrapper;
  /**
   * @minLength 0
   * @maxLength 255
   */
  postalCode: string;
  /** Relation type */
  relationType?: RelationType;
  ssnTail?: NillableString;
  /** States of America */
  state: StateType;
}

export interface GuarantorEditRequest {
  address1?: NillableString;
  address2?: NillableString;
  birthDate?: NillableLocalDate;
  birthSex?: NillableBirthSex;
  city?: NillableString;
  firstName?: NillableString;
  lastName?: NillableString;
  middleName?: NillableString;
  phone?: NillablePhoneWrapper;
  postalCode?: NillableString;
  relationType?: NillableRelationType;
  ssnTail?: NillableString;
  state?: NillableStateType;
}

export interface HealthCase {
  /** @format date */
  caseDate?: string;
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
}

export interface HealthCaseCreateRequest {
  /** @format date */
  caseDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  name: string;
}

export interface HealthCaseObject {
  /** @format uuid */
  id: string;
  type?: HealthCaseObjectType;
  value?: string;
}

export interface HealthCaseUpdateRequest {
  /** @format date */
  caseDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  name: string;
}

export interface HealthCaseWithObjectCount {
  /** @format date */
  caseDate?: string;
  description?: string;
  /** @format uuid */
  id: string;
  name?: string;
  /** @format int32 */
  objectCount?: number;
}

export interface HealthcareInsurancePolicy {
  /** @format date */
  endDate?: string;
  guarantor?: Guarantor;
  /** @format uuid */
  id: string;
  insurancePlan?: InsurancePlan;
  number?: string;
  primary?: boolean;
}

export interface HealthcareInsurancePolicyChangeRequest {
  /** Healthcare insurance policy ids to delete */
  deletedHealthcareInsurancePolicyIds?: string[];
  /**
   * Insurances to create
   * @maxItems 2
   * @minItems 0
   */
  healthcareInsurancePoliciesCreate?: HealthcareInsurancePolicyCreateRequest[];
  /**
   * Insurances to edit
   * @maxItems 2
   * @minItems 0
   */
  healthcareInsurancePoliciesEdit?: HealthcareInsurancePolicyEditRequest[];
}

export interface HealthcareInsurancePolicyCreateRequest {
  endDate?: NillableLocalDate;
  guarantor: GuarantorCreateRequest;
  /** @format uuid */
  insurancePlanId: string;
  /**
   * @minLength 0
   * @maxLength 128
   */
  number: string;
  primary: boolean;
}

export interface HealthcareInsurancePolicyEditRequest {
  endDate?: NillableLocalDate;
  guarantor?: NillableGuarantorEditRequest;
  /** @format uuid */
  id: string;
}

export type HomePhone = BaseBasePhone;

export type ImportResultDetail = BaseBaseResultDetail & {
  /** @format date */
  collected?: string;
  /** @format date */
  date?: string;
  healthCases?: HealthCase[];
  id: string;
  physician?: OrderingProvider;
  /** @format date */
  reported?: string;
  tests?: Test[];
};

export interface InsuranceCarrier {
  /** @format uuid */
  id: string;
  name?: string;
}

export interface InsurancePlan {
  carrier?: InsuranceCarrier;
  /** @format uuid */
  id: string;
  name?: string;
}

export type LaboratoryResultDetail = BaseBaseResultDetail & {
  fileExists: boolean;
  healthCases?: HealthCase[];
  id: string;
  orderDetails: OrderDetails;
  panels: Panel[];
  patient: Patient;
  products: Product[];
};

export type ManualResult = BaseBaseResult & {
  biomarkers?: string[];
  /** @format date */
  date?: string;
  hasFile?: boolean;
  healthCases?: HealthCase[];
  /** @format uuid */
  id: string;
  name?: string;
};

export type ManualResultDetail = BaseBaseResultDetail & {
  /** @format date */
  date?: string;
  description?: string;
  /** @format int64 */
  fileSize?: number;
  hasFile?: boolean;
  healthCases?: HealthCase[];
  /** @format uuid */
  id: string;
  name?: string;
  /** @deprecated */
  recognition?: boolean;
  recognitionStatus?: StorageRecognitionStatus;
  storageBiomarkers?: StorageBiomarker[];
};

export type MobilePhone = BaseBasePhone & {
  allowResultsDelivery?: boolean;
  main?: boolean;
  ownershipConfirmed?: boolean;
};

export interface NillableBirthSex {
  value?: BirthSex;
}

export interface NillableBoolean {
  value?: boolean;
}

export interface NillableEthnicityType {
  value?: EthnicityType;
}

export interface NillableGenderType {
  value?: GenderType;
}

export interface NillableGuarantorEditRequest {
  value?: GuarantorEditRequest;
}

export interface NillableLocalDate {
  /** @format date */
  value?: string;
}

export interface NillablePhoneWrapper {
  value?: string;
}

export interface NillableRaceType {
  value?: RaceType;
}

export interface NillableRelationType {
  /** Relation type */
  value?: RelationType;
}

export interface NillableSexualOrientationType {
  value?: SexualOrientationType;
}

export interface NillableStateType {
  /** States of America */
  value?: StateType;
}

export interface NillableString {
  value?: string;
}

export interface Notification {
  /** @format date-time */
  createdTime?: string;
  description?: string;
  /** @format uuid */
  id: string;
  read?: boolean;
  subject?: string;
  type?: NotificationType;
}

export interface NotificationsConnection {
  applicationId?: string;
  /** @format int32 */
  channels?: number;
  /** @format uuid */
  connectionId?: string;
  /** @format int32 */
  expired?: number;
  host?: string;
  password?: string;
  queue?: string;
  user?: string;
  virtualHost?: string;
  wssUrl?: string;
}

export interface OrderDetails {
  /** @format date */
  collected?: string;
  /** @format int64 */
  number?: number;
  provider?: OrderingProvider;
  /** @format date */
  reported?: string;
  specimens?: Specimen[];
}

export interface OrderingProvider {
  firstName?: string;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
}

export interface PageBiomarker {
  hasNext: boolean;
  items?: Biomarker[];
}

export interface PageHealthCaseWithObjectCount {
  hasNext: boolean;
  items?: HealthCaseWithObjectCount[];
}

export interface PageRelationContactSearchResult {
  hasNext: boolean;
  items?: RelationContactSearchResult[];
}

export interface PageStorageFile {
  hasNext: boolean;
  items?: StorageFile[];
}

export interface Panel {
  code: string;
  /** @format uuid */
  id: string;
  name: string;
  products?: Product[];
}

export interface Patient {
  /** @format date */
  birthDate?: string;
  birthSex?: BirthSex;
  firstName?: string;
  lastName?: string;
  middleName?: string;
}

export type PhoneSentRelationRequestResult =
  BaseBaseSentRelationRequestResult & {
    phone?: string;
  };

export interface PhoneUpdateRequest {
  allowResultDelivery?: NillableBoolean;
}

export type PlanAppointmentInsurance = BaseBaseAppointmentInsuranceRequest & {
  /** Insurance plan */
  plan?: InsurancePlan;
};

export interface Product {
  code: string;
  /** @format uuid */
  id: string;
  name: string;
  tests: Test[];
}

export interface ProfessionalInfo {
  account?: AccountDetails;
  active?: boolean;
  addresses?: CompanyAddress[];
  appointmentTypes?: AppointmentType[];
  periodAvailability?: PeriodAvailabilityType;
  specialities?: Speciality[];
  speciality?: Speciality;
  /** @format double */
  totalRating?: number;
  typePrefix?: string;
  typeSuffix?: string;
}

export interface ProfessionalShortInfo {
  account?: AccountDetails;
  specialities?: Speciality[];
  speciality?: Speciality;
  typePrefix?: string;
  typeSuffix?: string;
}

export interface ProfessionalSlots {
  /** @format date */
  date?: string;
  slots?: Slot[];
}

export interface ProfessionalSlotsRequest {
  /**
   * Professional address id
   * @format uuid
   */
  addressId: string;
  /** period */
  period: DatePeriod;
  /**
   * Appointment types
   * @uniqueItems true
   */
  types: AppointmentType[];
}

export interface Profile {
  actualAddresses?: Address;
  avatarUrl?: string;
  contact?: Contact;
  emails?: Email[];
  healthcareInsurancePolicies?: HealthcareInsurancePolicy[];
  /** Phones */
  phones?: BasePhone[];
  relations?: Relation[];
}

export interface QualityReference {
  isOutOfRef?: boolean;
  value?: string;
}

export interface Reference {
  isOutOfRef?: boolean;
  /** @format double */
  maxValue?: number;
  /** @format double */
  minValue?: number;
}

export interface RejectedReason {
  comment?: string;
  name?: string;
}

export interface Relation {
  avatarUrl?: string;
  /** Short contact info for relations */
  contact?: RelationContact;
  /** @format uuid */
  id: string;
  /** Relation type */
  type?: RelationType;
}

export interface RelationAccountAccess {
  /** Account access type */
  access?: AccountAccessType;
  /** @format date */
  beginDate?: string;
  /** @format date */
  endDate?: string;
  /** @format uuid */
  id: string;
}

/** Short contact info for relations */
export interface RelationContact {
  birthDate?: string;
  firstName?: string;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
}

export interface RelationContactBatchCreateRequest {
  /** Create new address */
  address?: AddressChangeRequest;
  /**
   * Birth Date
   * @format date
   */
  birthDate: string;
  /** Birth sex */
  birthSex: BirthSex;
  /** Email */
  email?: string;
  /** Ethnicity */
  ethnicity?: EthnicityType;
  /**
   * First name
   * @max 50
   * @minLength 0
   * @maxLength 50
   */
  firstName: string;
  /** Gender */
  gender?: GenderType;
  /** Create new insurance */
  insurance?: RelationContactInsuranceCreateRequest;
  /**
   * Use account insurance
   * @format uuid
   */
  insuranceId?: string;
  /**
   * Last name
   * @max 50
   * @minLength 0
   * @maxLength 50
   */
  lastName: string;
  /**
   * Middle name
   * @max 50
   * @minLength 0
   * @maxLength 50
   */
  middleName?: string;
  /** Phone */
  phone?: string;
  /** Race */
  race?: RaceType;
  recaptcha?: string;
  /** Relation type */
  relationType: RequestRelationType;
  /** SexualOrientation */
  sexualOrientation?: SexualOrientationType;
}

export interface RelationContactEditRequest {
  /** Birth Date */
  birthDate?: NillableLocalDate;
  /** Birth sex */
  birthSex?: NillableBirthSex;
  /** Ethnicity */
  ethnicity?: NillableEthnicityType;
  /**
   * First name
   * @max 50
   */
  firstName?: NillableString;
  /** Gender */
  gender?: NillableGenderType;
  /**
   * Last name
   * @max 50
   */
  lastName?: NillableString;
  /**
   * Middle name
   * @max 50
   */
  middleName?: NillableString;
  /** Race */
  race?: NillableRaceType;
  /** SexualOrientation */
  sexualOrientation?: NillableSexualOrientationType;
  /** SSN tail */
  ssnTail?: NillableString;
}

export interface RelationContactInsuranceCreateRequest {
  endDate?: NillableLocalDate;
  guarantor: GuarantorCreateRequest;
  /** @format uuid */
  insurancePlanId: string;
  /**
   * @minLength 0
   * @maxLength 128
   */
  number: string;
  primary: boolean;
}

/** Relation contact search request */
export interface RelationContactSearch {
  /** Search filter */
  filter?: string;
  /**
   * @format int32
   * @min 1
   * @max 30
   */
  perPage: number;
  /** Policy number */
  policyNumber?: string;
  recaptcha?: string;
  /** Relation type */
  relationType: RequestRelationType;
  /**
   * @format int32
   * @min 0
   * @default "0"
   */
  startPage?: number;
}

export interface RelationContactSearchResult {
  accountAvatarUrl?: string;
  /** Account status */
  accountStatus?: AccountStatus;
  /** @format date */
  birthDate?: string;
  birthDateS?: string;
  /** @deprecated */
  email?: string;
  emails?: Email[];
  firstName?: string;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
  /** @deprecated */
  phone?: string;
  phones?: BasePhone[];
  policies?: HealthcareInsurancePolicy[];
  /** @deprecated */
  policyNumber?: string;
  /** Base relation error */
  relationError?: BaseRelationError;
  relationErrors?: BaseRelationError[];
  ssnTail?: string;
}

export interface RelationContactSimilarError {
  errors?: RelationContactSimilarError[];
}

export type RelationDuplicateError = BaseBaseRelationError & {
  /** @format uuid */
  relationId?: string;
};

export interface RelationProfile {
  accesses?: RelationAccountAccess[];
  actualAddresses?: Address;
  avatarUrl?: string;
  contact?: Contact;
  emails?: Email[];
  healthcareInsurancePolicies?: HealthcareInsurancePolicy[];
  /** Phones */
  phones?: BasePhone[];
  relations?: Relation[];
}

export interface RelationRequest {
  avatarUrl?: string;
  /** Short contact info for relation requests */
  contact?: RelationRequestContact;
  /** @format date-time */
  createdDate?: string;
  emails?: Email[];
  /** @format uuid */
  id: string;
  phones?: BasePhone[];
  /** Relation type */
  type?: RelationType;
}

/** Short contact info for relation requests */
export interface RelationRequestContact {
  firstName?: string;
  /** @format uuid */
  id: string;
  lastName?: string;
  middleName?: string;
}

export interface RelationRequestCreateRequest {
  /**
   * Requested Contact Identifier
   * @format uuid
   */
  contactId: string;
  recaptcha?: string;
  /** Relation Type */
  relationType: RequestRelationType;
}

export type RelationRequestDuplicateError = BaseBaseRelationError & {
  /** @format date-time */
  createdDate?: string;
};

export interface RelationRequests {
  incoming?: RelationRequest[];
  outgoing?: RelationRequest[];
}

export interface RescheduleAppointmentRequest {
  /**
   * Address id
   * @format uuid
   */
  addressId: string;
  /** Appointment type */
  appointmentType: AppointmentType;
  /**
   * End date
   * @format date-time
   */
  endDate: string;
  /**
   * Start date
   * @format date-time
   */
  startDate: string;
}

export type Result = BaseBaseResult & {
  /** @format date */
  collected?: string;
  flag?: FlagType;
  healthCases?: HealthCase[];
  id: string;
  onHold?: boolean;
  physician?: OrderingProvider;
  tests?: TestShort[];
  unread?: boolean;
};

export interface ResultFileData {
  contentType?: string;
  data?: string;
}

export interface SearchAnonymousReportRequest {
  /** @format date */
  birthDate: string;
  key: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  lastName: string;
  previousKey?: string;
  recaptcha?: string;
}

export interface SearchAnonymousResultRequest {
  /** @format date */
  birthDate: string;
  key: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  lastName: string;
  recaptcha?: string;
}

export interface SendRequest {
  email: string;
}

export interface SharedLink {
  /** URL */
  url?: string;
}

export interface SharedStorage {
  files?: StorageFile[];
  /** @format uuid */
  id: string;
}

export interface SharedStorageCreateRequest {
  /**
   * End Date
   * @format date
   */
  endDate?: string;
  /** Access password */
  password?: string;
  /**
   * Storage Ids
   * @uniqueItems true
   */
  storageIds: string[];
}

export interface SharedStorageDetails {
  /** @format uuid */
  id: string;
  storageDetails?: StorageDetails[];
}

export interface SharedStorageRequest {
  password?: string;
}

export interface Slot {
  /**
   * from
   * @format partial-time
   */
  from?: string;
  /**
   * to
   * @format partial-time
   */
  to?: string;
  /** Type */
  types?: AppointmentType[];
}

export interface Speciality {
  /** @format uuid */
  id: string;
  isPrimary?: boolean;
  name?: string;
}

export interface Specimen {
  /** @format date */
  collected?: string;
  /** @format int64 */
  number?: number;
  /** @format date */
  reported?: string;
}

export interface StorageBiomarker {
  biomarker?: string;
  biomarkerObj?: Biomarker;
  biomarkerUnit?: BiomarkerUnit;
  /** @format uuid */
  id: string;
  unit?: string;
  value?: string;
}

export interface StorageBiomarkerCreate {
  /** @format uuid */
  biomarkerId?: string;
  /** @format uuid */
  biomarkerUnitId?: string;
  value: string;
}

export interface StorageBiomarkerEdit {
  /** @format uuid */
  biomarkerId?: string;
  /** @format uuid */
  biomarkerUnitId?: string;
  /** @format uuid */
  id: string;
  value: string;
}

export interface StorageDetails {
  biomarkers?: StorageBiomarker[];
  category?: StorageFileCategory;
  /** @format date */
  date?: string;
  description?: string;
  favorite?: boolean;
  healthCases?: HealthCase[];
  /** @format uuid */
  id: string;
  name?: string;
  recognition?: boolean;
  recognitionStatus?: StorageRecognitionStatus;
  /** @format int64 */
  size?: number;
  type?: StorageFileType;
}

export interface StorageFile {
  category?: StorageFileCategory;
  /** @format date */
  date?: string;
  description?: string;
  favorite?: boolean;
  healthCases?: HealthCase[];
  /** @format uuid */
  id: string;
  name?: string;
  recognition?: boolean;
  recognitionStatus?: StorageRecognitionStatus;
  /** @format int64 */
  size?: number;
  type?: StorageFileType;
}

export interface StorageFileCreateRequest {
  category: StorageFileCategory;
  createBiomarkers?: StorageBiomarkerCreate[];
  date?: NillableLocalDate;
  description?: NillableString;
  favorite?: NillableBoolean;
  /** @uniqueItems true */
  healthCaseIds?: string[];
  name?: NillableString;
  recognize?: boolean;
}

export interface StorageFileData {
  contentType?: string;
  data?: string;
}

export interface StorageFileEditRequest {
  category: StorageFileCategory;
  createBiomarkers?: StorageBiomarkerCreate[];
  date?: NillableLocalDate;
  description?: NillableString;
  editBiomarkers?: StorageBiomarkerEdit[];
  favorite?: NillableBoolean;
  /** @uniqueItems true */
  healthCaseIds?: string[];
  name?: NillableString;
}

export interface StorageThumbnail {
  data?: StorageFileData;
  /** @format uuid */
  id: string;
  type?: StorageThumbnailType;
}

export interface StorageThumbnailRequest {
  /** @uniqueItems true */
  fileIds: string[];
  /** @uniqueItems true */
  types: StorageThumbnailType[];
}

export interface Test {
  autoComment?: string;
  code: string;
  comment?: string;
  criticalReference?: Reference;
  /** @format uuid */
  id: string;
  loinc?: string;
  name: string;
  qualityReference?: QualityReference;
  reference?: Reference;
  rejectedReasons?: RejectedReason[];
  status: TestStatus;
  units?: string;
  value?: string;
}

export interface TestShort {
  name?: string;
}

export interface ThresholdError {
  /** @format int64 */
  expiredSeconds?: number;
}

export interface UnreadMessageCount {
  /** @format int64 */
  count?: number;
}

export type UnsentRelationRequestResult = BaseBaseSentRelationRequestResult;

export interface UpdateAppointmentRequest {
  /** Files to delete */
  deletedFileIds?: string[];
  /**
   * @minLength 0
   * @maxLength 500
   */
  description?: string;
  /** Saved files */
  files?: AppointmentFile[];
  /**
   * Patient height
   * @format double
   * @min 0
   * @max 8.2
   */
  height?: number;
  /**
   * Patient weight
   * @format double
   * @min 0
   * @max 1323
   */
  weight?: number;
}

export interface UpdateObjectHealthCase {
  /** @format uuid */
  healthCaseId: string;
}

/** Object with error message «Bad request» */
export interface ValidationError {
  /** OWNER_ROLE_NOT_FOUND, ROLE_NOT_FOUND, ROLE_COMPANY_MODULE_EXISTS, COMPANY_MODULE_NOT_FOUND, COMPANY_MODULE_ALREADY_EXISTS, ACCOUNT_COMPANY_MODULE_ROLE_EXISTS, ACCOUNT_COMPANY_INVITE_NOT_FOUND, ACCOUNT_COMPANY_INVITE_EXPIRED, ACCOUNT_COMPANY_INVITE_EXISTS, PERMISSIONS_NOT_FOUND, CURRENT_PASSWORD_INCORRECT, NEW_PASSWORD_EQUALS_CURRENT_PASSWORD, MOBILE_PHONE_REQUIRED, REMOVE_MAIN_PHONE, EMAIL_EXISTS, EMAIL_NOT_CONFIRMED, EMAIL_CONFIRMATION_TOKEN_ERROR, REMOVE_MAIN_EMAIL, NPI_NOT_ACTIVE, PARENT_NPI_REQUIRED, REQUEST_ORIGIN_NOT_FOUND, UNPROCESSABLE_URL, CONTACT_NOT_EXISTS, ACCOUNT_NOT_EXISTS, FUTURE_OR_PRESENT_DATE, NOT_NULL, NOT_BLANK, NOT_EMPTY, ONLY_UPPER_LETTERS, EMAIL_VALIDATION_ERROR, INVALID_FORMAT_ERROR, PHONE_VALIDATION_ERROR, MAX_SIZE_4000, MAX_SIZE_1000, MAX_SIZE_500, MAX_SIZE_255, MAX_SIZE_128, MAX_SIZE_100, MAX_SIZE_55, MAX_SIZE_50, MAX_SIZE_40, MAX_SIZE_4, MAX_SIZE_2, MIN_0, MIN_1, MAX_2, MAX_3, MAX_5, MAX_30, MAX_108, MAX_8_2, MAX_1323, CHANGE_FORBIDDEN, ZIP_CODE_NUMBER_VALIDATION_ERROR, FUTURE_DATE, MAX_UPLOAD_SIZE_EXCEEDED, FILE_TYPE_UNSUPPORTED, DATE_PERIOD_VALIDATION_ERROR, RECAPTCHA_VALIDATION_ERROR, BIRTHDATE_VALIDATION_ERROR, HEALTH_CASE_OBJECT_UNIQUE, STORAGE_FILE_NOT_FOUND, SHARED_STORAGE_NOT_FOUND, STORAGE_BIOMARKER_NOT_FOUND, BIOMARKER_BIOMARKER_UNIT_NOT_FOUND, MODIFICATION_FORBIDDEN, MIME_TYPE_NOT_SUPPORTED, HEALTHCARE_INSURANCE_POLICY_NOT_EXISTS, INSURANCE_PLAN_NOT_EXISTS, APPOINTMENT_NOT_EXISTS, APPOINTMENT_WRONG_STATUS, APPOINTMENT_REVIEW_EXISTS, CONTACT_NOT_EXISTS, ACCOUNT_NOT_EXISTS, RECOGNIZE_LABORATORY_REPORT, CREATE_BIOMARKER_ERROR, EDIT_BIOMARKER_ERROR, ACCESS_CREATE_ERROR, RELATIONS_NOT_EXISTS, EMAIL_EXISTS, EMAIL_NOT_CONFIRMED, EMAIL_CONFIRMED, REMOVE_MAIN_EMAIL, PHONE_CONFIRMED, PHONE_NOT_CONFIRMED, PHONE_EXISTS, MOBILE_PHONE_REQUIRED, REMOVE_MAIN_PHONE, PHONE_NOT_FOUND, EMAIL_NOT_FOUND, IDENTITY_COMMON_VALIDATION_ERROR, CATALOG_COMMON_VALIDATION_ERROR, PROFESSIONAL_SLOT_BUSY, PROFESSIONAL_SLOT_UNAVAILABLE, BOOKING_UNKNOWN_VALIDATION_ERROR, CONTACT_COMMON_VALIDATION_ERROR, BIRTH_CERTIFICATE_NUMBER_VALIDATION_ERROR, DRIVER_LICENSE_NUMBER_VALIDATION_ERROR, EMAIL_VALIDATION_ERROR, GREEN_CARD_NUMBER_VALIDATION_ERROR, PHONE_VALIDATION_ERROR, SOCIAL_SECURITY_NUMBER_TAIL_VALIDATION_ERROR, CONTACT_RELATION_TYPE_EMC_UNIQUE, CONTACT_RELATION_UNIQUE, CONTACT_BIRTHDATE_NOT_NULL, CONTACT_BIRTHDATE_MUST_BE_OVER_EIGHTEEN, CONTACT_BIRTHDATE_MUST_BE_UNDER_EIGHTEEN, ENTITY_EXISTS_ERROR, ENTITY_DELETED_ERROR, ENTITIES_EQUALS_ERROR, CONTACT_PHONE_TYPE_MOBILE_UNIQUE, ZIP_CODE_NUMBER_VALIDATION_ERROR, CONTACT_EMAIL_UNIQUE, COUNTRY_CODE_VALIDATION_ERROR, PASSPORT_NUMBER_VALIDATION_ERROR, NOT_NULL, NOT_EMPTY, NOT_BLANK, MIN_SIZE, MAX_SIZE, DYNAMIC_COMMON_VALIDATION_ERROR, ACCOUNT_ACCESS_REQUEST_EXISTS, ACCOUNT_ACCESS_REQUEST_END_DATE_PAST, ACCOUNT_BY_CONTACT_EXISTS, ACCOUNT_BY_NPI_EXISTS, NPI_VERIFICATION_EXISTS, COMPANY_BY_NPI_EXISTS, COMPANY_NOT_EXISTS, SPECTATE_PERMISSIONS_EMPTY, ACCESS_EXISTS, NPI_NOT_ACTIVE, CODE_VALIDATION_ERROR, ACCOUNT_NOT_FOUND, ACCOUNT_COMPANY_NOT_FOUND, ACCOUNT_COMPANY_EXISTS, ACCOUNT_COMPANY_ACTIVE, COMPANY_NOT_FOUND, OWNER_ROLE_NOT_FOUND, CONTACT_NOT_FOUND, CONTACT_PHONE_NOT_FOUND, CONTACT_EMAIL_NOT_FOUND, CONTACT_HAS_SIMILAR, CONTACT_VALIDATION_ERROR, NPI_NOT_FOUND, NPI_TYPE_INCORRECT, PHONE_NOT_FOUND, MODIFICATION_FORBIDDEN, NPI_VERIFICATION_NOT_FOUND, NPI_VERIFICATION_DESCRIPTION_NOT_NULL, ACCOUNT_INVITE_EXISTS, ACCOUNT_INVITE_NOT_FOUND, ACCOUNT_INVITE_EXPIRED, ACCOUNT_INVITE_AUTHORIZED, NEW_PASSWORD_EQUALS_CURRENT_PASSWORD, CURRENT_PASSWORD_INCORRECT, AT_LEAST_ONE_BILL_TYPE_MUST_BE_TRUE, PASSPORT_COMMON_VALIDATION_ERROR, REPORT_COMMON_VALIDATION_ERROR */
  error?: string;
  /** Array of field errors */
  fieldErrors?: {
    /** OWNER_ROLE_NOT_FOUND, ROLE_NOT_FOUND, ROLE_COMPANY_MODULE_EXISTS, COMPANY_MODULE_NOT_FOUND, COMPANY_MODULE_ALREADY_EXISTS, ACCOUNT_COMPANY_MODULE_ROLE_EXISTS, ACCOUNT_COMPANY_INVITE_NOT_FOUND, ACCOUNT_COMPANY_INVITE_EXPIRED, ACCOUNT_COMPANY_INVITE_EXISTS, PERMISSIONS_NOT_FOUND, CURRENT_PASSWORD_INCORRECT, NEW_PASSWORD_EQUALS_CURRENT_PASSWORD, MOBILE_PHONE_REQUIRED, REMOVE_MAIN_PHONE, EMAIL_EXISTS, EMAIL_NOT_CONFIRMED, EMAIL_CONFIRMATION_TOKEN_ERROR, REMOVE_MAIN_EMAIL, NPI_NOT_ACTIVE, PARENT_NPI_REQUIRED, REQUEST_ORIGIN_NOT_FOUND, UNPROCESSABLE_URL, CONTACT_NOT_EXISTS, ACCOUNT_NOT_EXISTS, FUTURE_OR_PRESENT_DATE, NOT_NULL, NOT_BLANK, NOT_EMPTY, ONLY_UPPER_LETTERS, EMAIL_VALIDATION_ERROR, INVALID_FORMAT_ERROR, PHONE_VALIDATION_ERROR, MAX_SIZE_4000, MAX_SIZE_1000, MAX_SIZE_500, MAX_SIZE_255, MAX_SIZE_128, MAX_SIZE_100, MAX_SIZE_55, MAX_SIZE_50, MAX_SIZE_40, MAX_SIZE_4, MAX_SIZE_2, MIN_0, MIN_1, MAX_2, MAX_3, MAX_5, MAX_30, MAX_108, MAX_8_2, MAX_1323, CHANGE_FORBIDDEN, ZIP_CODE_NUMBER_VALIDATION_ERROR, FUTURE_DATE, MAX_UPLOAD_SIZE_EXCEEDED, FILE_TYPE_UNSUPPORTED, DATE_PERIOD_VALIDATION_ERROR, RECAPTCHA_VALIDATION_ERROR, BIRTHDATE_VALIDATION_ERROR, HEALTH_CASE_OBJECT_UNIQUE, STORAGE_FILE_NOT_FOUND, SHARED_STORAGE_NOT_FOUND, STORAGE_BIOMARKER_NOT_FOUND, BIOMARKER_BIOMARKER_UNIT_NOT_FOUND, MODIFICATION_FORBIDDEN, MIME_TYPE_NOT_SUPPORTED, HEALTHCARE_INSURANCE_POLICY_NOT_EXISTS, INSURANCE_PLAN_NOT_EXISTS, APPOINTMENT_NOT_EXISTS, APPOINTMENT_WRONG_STATUS, APPOINTMENT_REVIEW_EXISTS, CONTACT_NOT_EXISTS, ACCOUNT_NOT_EXISTS, RECOGNIZE_LABORATORY_REPORT, CREATE_BIOMARKER_ERROR, EDIT_BIOMARKER_ERROR, ACCESS_CREATE_ERROR, RELATIONS_NOT_EXISTS, EMAIL_EXISTS, EMAIL_NOT_CONFIRMED, EMAIL_CONFIRMED, REMOVE_MAIN_EMAIL, PHONE_CONFIRMED, PHONE_NOT_CONFIRMED, PHONE_EXISTS, MOBILE_PHONE_REQUIRED, REMOVE_MAIN_PHONE, PHONE_NOT_FOUND, EMAIL_NOT_FOUND, IDENTITY_COMMON_VALIDATION_ERROR, CATALOG_COMMON_VALIDATION_ERROR, PROFESSIONAL_SLOT_BUSY, PROFESSIONAL_SLOT_UNAVAILABLE, BOOKING_UNKNOWN_VALIDATION_ERROR, CONTACT_COMMON_VALIDATION_ERROR, BIRTH_CERTIFICATE_NUMBER_VALIDATION_ERROR, DRIVER_LICENSE_NUMBER_VALIDATION_ERROR, EMAIL_VALIDATION_ERROR, GREEN_CARD_NUMBER_VALIDATION_ERROR, PHONE_VALIDATION_ERROR, SOCIAL_SECURITY_NUMBER_TAIL_VALIDATION_ERROR, CONTACT_RELATION_TYPE_EMC_UNIQUE, CONTACT_RELATION_UNIQUE, CONTACT_BIRTHDATE_NOT_NULL, CONTACT_BIRTHDATE_MUST_BE_OVER_EIGHTEEN, CONTACT_BIRTHDATE_MUST_BE_UNDER_EIGHTEEN, ENTITY_EXISTS_ERROR, ENTITY_DELETED_ERROR, ENTITIES_EQUALS_ERROR, CONTACT_PHONE_TYPE_MOBILE_UNIQUE, ZIP_CODE_NUMBER_VALIDATION_ERROR, CONTACT_EMAIL_UNIQUE, COUNTRY_CODE_VALIDATION_ERROR, PASSPORT_NUMBER_VALIDATION_ERROR, NOT_NULL, NOT_EMPTY, NOT_BLANK, MIN_SIZE, MAX_SIZE, DYNAMIC_COMMON_VALIDATION_ERROR, ACCOUNT_ACCESS_REQUEST_EXISTS, ACCOUNT_ACCESS_REQUEST_END_DATE_PAST, ACCOUNT_BY_CONTACT_EXISTS, ACCOUNT_BY_NPI_EXISTS, NPI_VERIFICATION_EXISTS, COMPANY_BY_NPI_EXISTS, COMPANY_NOT_EXISTS, SPECTATE_PERMISSIONS_EMPTY, ACCESS_EXISTS, NPI_NOT_ACTIVE, CODE_VALIDATION_ERROR, ACCOUNT_NOT_FOUND, ACCOUNT_COMPANY_NOT_FOUND, ACCOUNT_COMPANY_EXISTS, ACCOUNT_COMPANY_ACTIVE, COMPANY_NOT_FOUND, OWNER_ROLE_NOT_FOUND, CONTACT_NOT_FOUND, CONTACT_PHONE_NOT_FOUND, CONTACT_EMAIL_NOT_FOUND, CONTACT_HAS_SIMILAR, CONTACT_VALIDATION_ERROR, NPI_NOT_FOUND, NPI_TYPE_INCORRECT, PHONE_NOT_FOUND, MODIFICATION_FORBIDDEN, NPI_VERIFICATION_NOT_FOUND, NPI_VERIFICATION_DESCRIPTION_NOT_NULL, ACCOUNT_INVITE_EXISTS, ACCOUNT_INVITE_NOT_FOUND, ACCOUNT_INVITE_EXPIRED, ACCOUNT_INVITE_AUTHORIZED, NEW_PASSWORD_EQUALS_CURRENT_PASSWORD, CURRENT_PASSWORD_INCORRECT, AT_LEAST_ONE_BILL_TYPE_MUST_BE_TRUE, PASSPORT_COMMON_VALIDATION_ERROR, REPORT_COMMON_VALIDATION_ERROR */
    error?: string;
    /** Field name */
    field?: string;
  }[];
}

export type WorkPhone = BaseBasePhone;

/** type */
export enum TypeEnum {
  CARRIER = 'CARRIER',
  PLAN = 'PLAN',
}

interface BaseBaseAppointmentInsuranceRequest {
  /** Policy number */
  policyNumber?: string;
  /** type */
  type?: BaseBaseAppointmentInsuranceRequestTypeEnum;
}

type BaseBaseAppointmentInsuranceRequestTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** Base phone */
interface BaseBasePhone {
  /** @format uuid */
  id: string;
  phone?: string;
  /** Phone type */
  type?: PhoneType;
}

type BaseBasePhoneTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** Base relation error */
interface BaseBaseRelationError {
  /** Relation error type */
  type?: RelationErrorType;
}

type BaseBaseRelationErrorTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** Base result */
interface BaseBaseResult {
  type: ResultType;
}

type BaseBaseResultTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** Base result detail */
interface BaseBaseResultDetail {
  type?: ResultType;
}

type BaseBaseResultDetailTypeMapping<Key, Type> = {
  type: Key;
} & Type;

/** Base Sent Relation Request Result */
interface BaseBaseSentRelationRequestResult {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  /** Relation Request Send Type */
  type?: RelationRequestSendType;
}

type BaseBaseSentRelationRequestResultTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export interface UpdateAppointmentPayload {
  data: UpdateAppointmentRequest;
  files?: File[];
}

export interface GetBiomarkersParams {
  phrase?: string;
  /**
   * @format int32
   * @min 0
   * @default 0
   */
  startPage?: number;
  /**
   * @format int32
   * @min 1
   * @max 30
   */
  perPage: number;
}

export interface GetBmiRecommendationParams {
  /** @format date */
  birthDate: string;
  birthSex: BirthSex;
  bmi: number;
}

export interface GetGlobalNotificationsParams {
  /**
   * @format int32
   * @min 0
   * @default 0
   */
  startPage?: number;
  /**
   * @format int32
   * @min 1
   * @max 30
   */
  perPage: number;
  /** Read */
  read?: boolean;
}

export interface SearchHealthCasesParams {
  phrase?: string;
  /** @format date */
  from?: string;
  /** @format date */
  to?: string;
  /**
   * @format int32
   * @min 0
   * @default 0
   */
  startPage?: number;
  /**
   * @format int32
   * @min 1
   * @max 30
   */
  perPage: number;
}

export interface GetInsuranceCarriersParams {
  filter?: string;
}

export interface GetInsurancePlansByInsuranceCarrierParams {
  /** @format uuid */
  insuranceCarrierId: string;
}

export interface CreateRelationContactParams {
  /** @default false */
  force?: boolean;
}

export interface GetRelationResultsByIdParams {
  includeStorageResults?: boolean;
  /** @format uuid */
  relationId: string;
}

export interface GetRelationResultByIdParams {
  /** @default "LABORATORY" */
  type?: ResultType;
  /** @format uuid */
  relationId: string;
  resultId: string;
}

export interface DownloadRelationResultParams {
  /** @default "LABORATORY" */
  type?: ResultType;
  /** @format uuid */
  relationId: string;
  resultId: string;
}

export interface SendRelationResultParams {
  /** @default "LABORATORY" */
  type?: ResultType;
  /** @format uuid */
  relationId: string;
  resultId: string;
}

export interface GetResultsParams {
  includeStorageResults?: boolean;
}

export interface GetResultParams {
  /** @default "LABORATORY" */
  type?: ResultType;
  /** Result id */
  id: string;
}

export interface DownloadResultParams {
  /** @default "LABORATORY" */
  type?: ResultType;
  /** Result id */
  id: string;
}

export interface SendResultParams {
  /** @default "LABORATORY" */
  type?: ResultType;
  /** Result id */
  id: string;
}

export interface GetSharedStorageFileThumbnailsParams {
  /** @uniqueItems true */
  type: StorageThumbnailType[];
  /** @format uuid */
  id: string;
  /** @format uuid */
  fileId: string;
}

export interface CreateStorageFilePayload {
  data: StorageFileCreateRequest;
  /** @format binary */
  file?: File;
}

export interface SearchStorageFilesParams {
  phrase?: string;
  category?: StorageFileCategory;
  /** @default "ALL" */
  menu?: StorageMenu;
  cases?: string[];
  /** @format date */
  from?: string;
  /** @format date */
  to?: string;
  /**
   * @format int32
   * @min 0
   * @default 0
   */
  startPage?: number;
  /**
   * @format int32
   * @min 1
   * @max 30
   */
  perPage: number;
}

export interface UpdateStorageFilePayload {
  data: StorageFileEditRequest;
  /** @format binary */
  file?: File;
}

/** type */
export enum BaseBaseAppointmentInsuranceRequestTypeEnum {
  CARRIER = 'CARRIER',
  PLAN = 'PLAN',
}
